<template>
    <div>
        <div style="width: 100%;">
            <div :id="id"></div>
            <div>
                <span style="padding-right: 10px;font-size: 14px;" :key="item.path" v-for="item in cap_list">
                    <span class="stone" :class="{'bgb':item.c==1,'bgw':item.c==-1}" >{{item.path}}</span>
                    <span >{{item.coor}}</span>
                </span>
            </div>
            <div class="desc" :class="{'desc_transform':is_scale}" :style="{'font-size':fontsize+'px','margin-top':margintop+'px'}">
                {{desc}}
            </div>
        </div>
    </div>
</template>
<script>
    import '@/libs/ggo/wgo'
    import '@/libs/ggo/kifu'
    import '@/libs/ggo/sgfparser'
    import '@/libs/ggo/player'
    import '@/libs/ggo/basicplayer'
    import '@/libs/ggo/player.editable'
    import '@/libs/ggo/score'
    import '@/libs/ggo/player.maker'
    import '@/libs/ggo/player.trymove'
    export default {
        props: {
            title: {
                type: String,
                default: '上海弈客信息技术有限公司'
            },
            cap_list:{
                type:Array,
            },
            desc: {
                type: String,
                default: ''
            },
            fontsize: {
                type: String,
                default: '20'
            },
            margintop: {
                type: String,
                default: '30'
            },
            id: {
                type: String,
                default: '0'
            },
            sgf: {
                type: String,
                default: '(;SZ[19])'
            },
            show_move:{
                type: Number,
                default: 0
            },
            is_scale:{
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                player: null,
                markerConfig: {
                    markerStyle: 'LB',
                    markerNum:this.show_move,
                    lastMoveColor: '',
                    start: 0,
                },
            }
        },
        mounted() {
            this.initBoard()
        },
        methods: {
            // 初始化棋盘
            initBoard() {
                let self = this
                let element = document.getElementById(this.id)
                self.player = new WGo.BasicPlayer(element, {
                    sgf: this.sgf,
                    enableWheel: false,
                    displayVariations: false,
                    enableKeys: false,
                    markLastMove: false,
                    allowIllegalMoves: false,
                    board:{
                        theme:{ gridLinesColor:"#000",},
                        stoneHandler: WGo.Board.drawHandlers.MONO
                    },
                    update: function (e) {
                        if(!e.op&&self.cap_list){
                            let tempPos =WGo.clone(e.position)
                            let temp = WGo.clone(self.cap_list)
                            let addStone=[]
                            temp.forEach(item => {
                                if(tempPos.get(item.x,item.y)== 0){
                                    addStone.push(item)
                                    tempPos.set(item.x,item.y,item.c)
                                    self.player.board.addObject(
                                    {
                                        type: "PDFLB",
                                        x:item.x,
                                        y:item.y,
                                        c:item.c,
                                        text:item.path,
                                    });
                                }
                            });
                            addStone.forEach(item=>{
                                self.cap_list.forEach((cap,index)=>{
                                    if(item.path==cap.path){
                                        self.cap_list.splice(index,1); 
                                    }
                                })
                            })
                        }
                    }
                })
                self.player.setCoordinates(true)
                self.marker = new WGo.Player.Marker(
                    self.player,
                    self.player.board,
                    self.markerConfig
                )
                self.player.last()
            },
        }
    }
</script>
<style scoped>
    .desc {
        color: black;
        text-align: justify;
    }
    .desc_transform{
        -webkit-transform : scale(0.9,0.9) ;
    }

    .board {
        background: url("~@/libs/ggo/board.jpg") no-repeat;
        background-position: center;
        background-size: cover;
    }
    .stone{
        display: inline-block;
        border-radius: 100%;
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        border:1px solid #000;
        margin-right: 5px;
        font-size: 12px;
    }
    .bgb{
        background: #000;
        color: #fff;

    }
    .bgw{
        background: #fff;
        color: #000;
    }
</style>